import { render, staticRenderFns } from "./created-family-planning-data.vue?vue&type=template&id=50a336ae"
import script from "./created-family-planning-data.vue?vue&type=script&lang=ts"
export * from "./created-family-planning-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports